module.exports = __webpack_public_path__ + "img/title-4.78c36666.png";